export const codeViewerErrorsEnum = { err86: '86-ERROR' } as const
